<template>
    <ul class="form-stepper form-stepper-horizontal text-left mx-auto pl-0">
        <li v-for="(item,index) in step_list" v-if="index<step_list.length-2 || ((index==step_list.length-1 || index==step_list.length-2) && !skip_last)" :class="index+1<=current_step ?'form-stepper-active':'form-stepper-unfinished'" class="text-center form-stepper-list" :step="index+1">
            <step :step="index+1" :label="item"></step>
        </li>
    </ul>
</template>
  
  <script>
    
    import step from "@/components/CardManagement/step";

    export default {
      data() {
        return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        }
      },
      components:{
        step
      },
      props:['current_step','skip_last','step_list'],
      methods:{
        
      },
      mounted(){
        
      }
    }
  </script>